import * as tslib_1 from "tslib";
import { SLIDER_GALLERY_FEDOPS_APP_NAME, TRACK_EVENT_COLLECTION, translationPath, GALLERY_PUBLIC_DATA_PRESET_ID, DEFAULT_COLLECTION_ID, Experiments, } from '../constants';
import { getTranslations } from '@wix/wixstores-client-core/dist/src/viewer-script/utils';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
import { APP_DEFINITION_ID, PageMap, PubSubEvents } from '@wix/wixstores-client-core/dist/es/src/constants';
import { getStyleParamsWithDefaultsFunc } from '../getStyleParamsWithDefaultsFunc';
import { MultilingualService } from '@wix/wixstores-client-core/dist/src/multilingualService/multilingualService';
import { isWorker } from '@wix/wixstores-client-core/dist/es/src/viewer-script/utils';
import { create } from '@wix/fedops-logger';
var SliderGalleryStore = /** @class */ (function () {
    function SliderGalleryStore(styleParams, config, updateComponent, siteStore, productsService, compId, reportError, type) {
        this.styleParams = styleParams;
        this.config = config;
        this.updateComponent = updateComponent;
        this.siteStore = siteStore;
        this.productsService = productsService;
        this.compId = compId;
        this.reportError = reportError;
        this.type = type;
        this.fedopsLogger = create(SLIDER_GALLERY_FEDOPS_APP_NAME);
        this.isFedopsReport = true;
        this.relatedProductIds = [];
        this.MAX_PRODUCTS_IN_SLIDER = 32;
        //todo: COMPONENT === null is not tested, be this check can be removed after bolt will stop sending nulls https://wix.slack.com/archives/CAKBA7TDH/p1555852184003900
        this.config.publicData.COMPONENT = this.config.publicData.COMPONENT || {};
        var fedopsAppName = "" + SLIDER_GALLERY_FEDOPS_APP_NAME + (isWorker() ? '-ooi' : '');
        this.subscribe();
        if (isWorker()) {
            if (this.siteStore.experiments.enabled(Experiments.NewFedopsIntegration)) {
                var fedopsLoggerFactory = this.siteStore.platformServices.fedOpsLoggerFactory;
                this.fedopsLogger = fedopsLoggerFactory.getLoggerForWidget({
                    appId: APP_DEFINITION_ID,
                    widgetId: this.type,
                });
            }
            else {
                this.fedopsLogger = create(fedopsAppName, {
                    isWidgetLogger: true,
                    isServerSide: this.siteStore.isSSR(),
                    appId: APP_DEFINITION_ID,
                    metasiteId: this.siteStore.msid,
                    widgetId: this.type,
                });
            }
            this.fedopsLogger.appLoadStarted();
        }
        else {
            this.fedopsLogger = create(fedopsAppName);
        }
    }
    SliderGalleryStore.prototype.getCateogryProducts = function (_a) {
        var limit = _a.limit, offset = _a.offset;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.productsService.getCategoryProducts({ compId: this.compId, limit: limit, offset: offset })];
                    case 1:
                        _b.sent();
                        this.productIdToProductPageUrlMap = this.generateProductIdToProductPageUrlMap(this.productsService.products);
                        this.updateComponent({
                            products: this.productsService.products,
                            productIdToProductPageUrlMap: this.productIdToProductPageUrlMap,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SliderGalleryStore.prototype.padProductListWithPlaceholders = function () {
        if (this.productsService.products.length < this.effectiveTotalCount) {
            var realLength = this.productsService.products.length;
            this.productsService.products[this.effectiveTotalCount - 1] = undefined;
            this.productsService.products.fill({ isFake: true }, realLength, this.effectiveTotalCount);
        }
    };
    SliderGalleryStore.prototype.setInitialState = function (forceRender) {
        if (forceRender === void 0) { forceRender = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var numOfColumns, numOfSets, fetcher, _a, translations, response, url, products, props;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!forceRender && !this.shouldComponentRender()) {
                            return [2 /*return*/];
                        }
                        numOfColumns = this.config.style.styleParams.numbers.galleryColumns || 4;
                        numOfSets = 2;
                        fetcher = this.getDataFetcher();
                        return [4 /*yield*/, Promise.all([
                                getTranslations(translationPath(this.siteStore.baseUrls.galleryBaseUrl, this.siteStore.locale)),
                                fetcher(),
                                this.siteStore.getSectionUrl(PageMap.PRODUCT),
                            ]).catch(this.reportError)];
                    case 1:
                        _a = _b.sent(), translations = _a[0], response = _a[1], url = _a[2].url;
                        if (!(this.effectiveTotalCount > numOfSets * numOfColumns)) return [3 /*break*/, 3];
                        this.padProductListWithPlaceholders();
                        return [4 /*yield*/, this.productsService.getCategoryProducts({
                                compId: this.compId,
                                limit: numOfColumns * numOfSets,
                                offset: this.effectiveTotalCount - numOfColumns * numOfSets,
                            })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        products = this.productsService.products;
                        this.translations = translations;
                        this.productPageSectionUrl = url;
                        this.mainCollectionId = this.productsService.getMainCollectionId();
                        this.productIdToProductPageUrlMap = this.generateProductIdToProductPageUrlMap(products);
                        this.multilingualService = new MultilingualService(this.config.publicData.COMPONENT, response.appSettings.widgetSettings, this.siteStore.getMultiLangFields(), this.siteStore.locale);
                        props = this.getPropsToInject(products);
                        this.updateComponent(props);
                        if (this.siteStore.isSSR()) {
                            this.fedopsLogger.appLoaded();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SliderGalleryStore.prototype.onAppLoaded = function () {
        /* istanbul ignore next: hard to test it */
        if (this.isFedopsReport) {
            this.fedopsLogger.appLoaded();
            this.isFedopsReport = false;
        }
    };
    Object.defineProperty(SliderGalleryStore.prototype, "effectiveTotalCount", {
        get: function () {
            return Math.min(this.productsService.totalCount, this.MAX_PRODUCTS_IN_SLIDER);
        },
        enumerable: true,
        configurable: true
    });
    SliderGalleryStore.prototype.getPropsToInject = function (products) {
        return {
            products: products,
            isFirstPage: true,
            productIdToProductPageUrlMap: this.productIdToProductPageUrlMap,
            isLoaded: true,
            isInteractive: this.siteStore.isInteractive(),
            textsMap: this.getTextsMap(),
            isMobile: this.siteStore.isMobile(),
            isRTL: this.siteStore.isRTL(),
            mainCollectionId: this.mainCollectionId,
            cssBaseUrl: this.siteStore.baseUrls.galleryBaseUrl,
            openQuickView: this.openQuickView.bind(this),
            totalProducts: this.effectiveTotalCount,
            handleProductItemClick: this.handleProductItemClick.bind(this),
            isLiveSiteMode: this.siteStore.isSiteMode(),
            ravenUserContextOverrides: {
                id: this.siteStore.storeId,
            },
            getCategoryProducts: this.getCateogryProducts.bind(this),
            onAppLoaded: this.onAppLoaded.bind(this),
            experiments: {
                isArrowlessMobileSliderEnabled: this.siteStore.experiments.enabled(Experiments.ClientGalleryArrowlessMobileSlider),
                isRelatedItemsGalleryEnabled: this.siteStore.experiments.enabled(Experiments.RelatedItemsGallery),
                isClientGalleryUseAutoUpscaleEnabled: this.siteStore.experiments.enabled(Experiments.ClientGalleryUseAutoUpscale),
            },
        };
    };
    SliderGalleryStore.prototype.getTextsMap = function () {
        return {
            noProductsMessageText: this.translations.NO_PRODUCTS_MESSAGE_MAIN,
            productOutOfStockText: this.translations.OUT_OF_STOCK_LABEL,
            productPriceAfterDiscountSR: this.translations['sr.PRODUCT_PRICE_AFTER_DISCOUNT'],
            productPriceBeforeDiscountSR: this.translations['sr.PRODUCT_PRICE_BEFORE_DISCOUNT'],
            productPriceWhenThereIsNoDiscountSR: this.translations['sr.PRODUCT_PRICE_WHEN_THERE_IS_NO_DISCOUNT'],
            quickViewButtonText: this.translations.QUICK_VIEW,
            sliderGalleryNoProductsMessageText: this.translations.NO_PRODUCTS_MESSAGE_MINI_GALLERY_MAIN,
            sliderGalleryTitle: this.title,
        };
    };
    SliderGalleryStore.prototype.generateProductIdToProductPageUrlMap = function (products) {
        var _this = this;
        var res = {};
        products
            .filter(function (product) { return product && product.urlPart; })
            .forEach(function (p) {
            res[p.id] = _this.productPageSectionUrl + "/" + p.urlPart;
        });
        return res;
    };
    SliderGalleryStore.prototype.openQuickView = function (_a) {
        var productId = _a.productId, index = _a.index;
        var product = this.productsService.getProduct(productId);
        this.siteStore.biLogger.clickedOnProductQuickViewSf({
            productId: productId,
            hasRibbon: !!product.ribbon,
            hasOptions: !!product.options.length,
            index: index,
        }); // tslint:disable-line no-floating-promises
        this.productsService.quickViewProduct(productId, product.urlPart, this.compId, this.config.externalId); // tslint:disable-line no-floating-promises
        this.sendClickTrackEvent(product, index);
    };
    SliderGalleryStore.prototype.sendClickTrackEvent = function (product, index) {
        this.siteStore.windowApis.trackEvent('ClickProduct', {
            appDefId: APP_DEFINITION_ID,
            id: product.id,
            origin: 'Stores',
            name: product.name,
            list: 'Grid Gallery',
            category: TRACK_EVENT_COLLECTION,
            position: index,
            price: product.comparePrice || product.price,
            currency: this.siteStore.currency,
        });
    };
    SliderGalleryStore.prototype.handleProductItemClick = function (_a) {
        var _b = _a.biData, productId = _b.productId, index = _b.index;
        var product = this.productsService.getProduct(productId);
        this.productsService.storeNavigation(this.siteStore.siteApis.currentPage.id);
        this.siteStore.biLogger.clickOnProductBoxSf({
            productId: productId,
            hasRibbon: !!product.ribbon,
            hasOptions: !!product.options.length,
            index: index,
            productType: product.productType,
        }); // tslint:disable-line no-floating-promises
        this.siteStore.navigate({
            sectionId: PageMap.PRODUCT,
            state: product.urlPart,
            queryParams: undefined,
        }); // tslint:disable-line no-floating-promises
        this.sendClickTrackEvent(product, index);
    };
    SliderGalleryStore.prototype.updateState = function (newStyleParams, newPublicData) {
        this.config.publicData = newPublicData;
        this.styleParams = getStyleParamsWithDefaults(newStyleParams, function () {
            return getStyleParamsWithDefaultsFunc({ style: { styleParams: newStyleParams }, dimensions: undefined });
        });
        this.updateComponent({
            textsMap: this.getTextsMap(),
        });
    };
    Object.defineProperty(SliderGalleryStore.prototype, "galleryType", {
        get: function () {
            if (this.config.publicData.COMPONENT.presetId === GALLERY_PUBLIC_DATA_PRESET_ID.RELATED_PRODUCTS) {
                return 2 /* RELATED_PRODUCTS */;
            }
            return 1 /* COLLECTION */;
        },
        enumerable: true,
        configurable: true
    });
    SliderGalleryStore.prototype.getDataFetcher = function () {
        var _a;
        var _this = this;
        return (_a = {},
            _a[1 /* COLLECTION */] = function () {
                return _this.productsService.getInitialData({
                    externalId: _this.config.externalId,
                    compId: _this.compId,
                });
            },
            _a[2 /* RELATED_PRODUCTS */] = function () {
                return _this.productsService.getRelatedItems({
                    externalId: _this.config.externalId,
                    productIds: _this.relatedProductIds,
                });
            },
            _a)[this.galleryType];
    };
    SliderGalleryStore.prototype.subscribe = function () {
        var _this = this;
        if (this.galleryType === 2 /* RELATED_PRODUCTS */) {
            setTimeout(function () { return _this.relatedProductIds.length === 0 && _this.renderRelatedProducts(); }, 500);
            this.siteStore.pubSub.subscribe(PubSubEvents.RELATED_PRODUCTS, function (response) { return _this.renderRelatedProducts(response.data); }, true);
        }
    };
    SliderGalleryStore.prototype.renderRelatedProducts = function (productIds) {
        if (productIds === void 0) { productIds = []; }
        this.relatedProductIds = productIds.slice();
        this.setInitialState(true); // tslint:disable-line no-floating-promises
    };
    SliderGalleryStore.prototype.shouldComponentRender = function () {
        if (this.galleryType === 2 /* RELATED_PRODUCTS */ && this.relatedProductIds.length === 0) {
            return false;
        }
        return true;
    };
    Object.defineProperty(SliderGalleryStore.prototype, "title", {
        get: function () {
            if (this.galleryType === 1 /* COLLECTION */) {
                var collectionName = this.productsService.getMainCollectionId() === DEFAULT_COLLECTION_ID
                    ? this.translations['gallery.collection.allProducts']
                    : this.productsService.collectionName;
                return this.multilingualService.get('SLIDER_GALLERY_TITLE_COLLECTION') || collectionName;
            }
            return (this.multilingualService.get('SLIDER_GALLERY_TITLE_RELATED_PRODUCTS') ||
                this.translations['gallery.relatedProducts.default.title']);
        },
        enumerable: true,
        configurable: true
    });
    return SliderGalleryStore;
}());
export { SliderGalleryStore };
//# sourceMappingURL=SliderGalleryStore.js.map